import { SubmitHandler, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { UserAccountType } from "common/types/user";

import {
  getUserFamilyName,
  getUserGivenName
} from "seneca-common/features/user/state";
import { removeUndefinedKeys } from "seneca-common/utils/functions";

import { logConfirmNameOnSignUp } from "features/sign-up/sign-up-form/analytics";
import { optimisticallyUpdateAttributes } from "features/user";

type UserDetailsForm = {
  givenName?: string | null;
  familyName?: string | null;
  isSubscribedToMarketingEmails?: boolean;
};

type Props = {
  defaultValues: UserDetailsForm;
  accountType: UserAccountType;
};

export default function useSignUpUserDetailsForm({
  defaultValues,
  accountType
}: Props) {
  const dispatch = useDispatch();

  const givenName = useSelector(getUserGivenName);
  const familyName = useSelector(getUserFamilyName);

  const form = useForm<UserDetailsForm>({
    defaultValues: {
      givenName: defaultValues.givenName || givenName,
      familyName: defaultValues.familyName || familyName
    },
    mode: "onChange"
  });

  const onSubmit: SubmitHandler<UserDetailsForm> = values => {
    const userDetails = removeUndefinedKeys(values);

    logConfirmNameOnSignUp();
    dispatch(
      optimisticallyUpdateAttributes({
        ...userDetails,
        type: accountType
      })
    );
  };

  return { form, onFormSubmit: () => onSubmit(form.getValues()) };
}
